import { get, last } from 'lodash';

import { getTranslatedString } from '@skinsoft/ui';

import { Item } from './item-data-store';

// Selectors for Item type

export const id = (item: Item) => get(item, 'id');

export const type = (item: Item) => get(item, 'type')

export const manifestation = (item: Item) => get(item, 'linkToManifestation.referentManifestation');

export const permanentLocation = (item: Item) => get(item, 'locationItemSchema.permanentLocation.permanentLocation');

export const realTimeLocation = (item: Item) => get(item, 'locationItemSchema.realTimeLocation.realTimeLocation');

export const title = (item: Item, locale: string) => getTranslatedString(get(item, 'translatedTitle', ''), locale) as string || get(item, 'title');

export const creationDate = (item: Item) => get(item, 'descriptionWorkSchema.creationDates[0].date.dateFIAF', '')

export const institution = (item: Item) => get(item, 'institutionCreation')

export const inventoryNumber = (item: Item) => get(item, 'identificationWorkSchema.identifiers[0].identifier')

export const lastDateOfConditionReport = (item: Item) => get(item, 'stateItemSchema.lastDateOfConditionReport')

export const lastConditionReport = (item: Item) => get(item, 'lastConditionReport') as string

export const identifier = (item: Item, locale: string) => {
    const barCode = get(item, `identificationItemSchema.barCodes.translatedString.${locale}`);

    const uniqueIdentifier = get(item, 'identificationItemSchema.identifiers[0].identifier');

    return uniqueIdentifier || barCode || "...";
};


export const media = (item: Item) => {
    const otherMedia = get(item, 'associatedMedias.mediaFiles.0.mediaId', null);
    const third = get(item, 'associatedMedias.third');
    const second = get(item, 'associatedMedias.second');
    const first = get(item, 'associatedMedias.first');
    return first || second || third || otherMedia;
}

// TODO complete
export const dimensions = (item: Item) => ''
export const weight = (item: Item) => ''


